<div class="fx-layout-row">
  <div class="wrapper fx-flex--grow fx-flex--100--xs" *ngIf="project">
    <div class="heading" [hidden]="missingDependency" *ngIf="productCategory.filterOptions">
      <div class="product-descriptor" #productDescriptorDiv>
        <div>
          {{ currentMatOptions.quality | lowercase }} <mat-icon (click)="infoClicked($event, 'types')" svgIcon="information-outline"></mat-icon>
          <div>{{currentMatOptions.coreType | uppercase}} CORE, {{ currentMatOptions.thickness | uppercase }}</div>

        </div>
        <button mat-flat-button color="secondary" (click)="openMatFilters($event)">MORE MATS</button>
      </div>
      <mat-tab-group disableRipple="true"
                  (selectedTabChange)="onTabChanged($event)" [selectedIndex]="currentTabIndex" *ngIf="layers.length > 1">
        @for (layer of layers; track layer; let i = $index) {
        <mat-tab [label]="layer.title">
          <!--ng-template mat-tab-label>
            {{ tab.title }}
          </ng-template-->
        </mat-tab>
        }
      </mat-tab-group>
      <mat-icon (click)="infoClicked($event, 'layers')" svgIcon="information-outline" *ngIf="layers.length > 1"></mat-icon>
    </div>

    <div *ngIf="missingDependency === 'opening'" class="no-top-mat">
      Add an opening to select an accent mat.
      <br /><br />
      <button mat-flat-button (click)="addOpening($event)" color="primary">Add Opening</button>
    </div>
    <div *ngIf="missingDependency === 'topMat'" class="no-top-mat">
      Pick a primary mat before selecting an accent mat.
      <ng-container *ngIf="layers.length > 1">
        <button mat-flat-button (click)="currentTabIndex=0" color="primary">Choose Primary Mat</button>
      </ng-container>
    </div>
    <div *ngIf="missingDependency === 'bottomMatAllowed'" class="no-top-mat">
      Accent mat is not allowed for this project.
    </div>
    <div *ngIf="groupedProducts" [hidden]="missingDependency" class="products" #products>
      @for (productGroup of groupedProducts; track productGroup; let i = $index) {
      <div class="product-group">
        <div class="heading fx-layout-row fx-align--center-x">
          <h4>
            {{ productGroup.title}}
          </h4>
        </div>

        <div class="products-container">
          @for (product of productGroup.products; track product) {
          <div class="product" (click)="chooseMat($event, product)">

            <div class="swatch" [ngClass]="{ 'selected': isSelected(product)}">
              <img loading="lazy" [src]="product.thumb" [alt]="product.description">
              <mat-icon *ngIf="!product.active" svgIcon="lock"></mat-icon>
              <div class="sale" *ngIf="product.saleUnitPrice && product.saleUnitPrice < product.unitPrice">{{ 1 - product.saleUnitPrice / product.unitPrice | percent }} OFF</div>
            </div>

            <div>
              {{ product.description }}<br />
              #{{ product.code }}
            </div>
          </div>
          }

          @for (x of [0,1,2,3,4,5,6,7,8,9]; track x) {
            <div class="product extra"></div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  <div class="right-side" *ngIf="media.isMatched(BREAKPOINTS.GreaterThanXSmall) && !missingDependency && productCategory.filterOptions">
    <mbnm-filters #filters
                  [productData]="productCategory.products" productName="Mats" [options]="productCategory.filterOptions"
                  [skipNoMatchesWarning]="samplesMode"
                  (filterChanged)="availableMatProductsChanged($event)">
    </mbnm-filters>
    <div *ngIf="productCategory.projectProperty === 'topMat' && (!project.topMat || project.allowVGroove) && !samplesMode">
      <div class="title">
        <mat-icon svgIcon="information-outline" (click)="infoClicked($event, 'vGroove')"></mat-icon>
        <mat-checkbox [(ngModel)]="vGrooveYesNo" labelPosition="before" (change)="vGrooveChanged()">
          {{ vGrooveYesNo ? 'V-Groove Offset' : 'Include V-Groove' }}
        </mat-checkbox>
      </div>
        <mat-form-field subscriptSizing="dynamic" *ngIf="vGrooveYesNo && project.availableVGrooveOffsets">
          <mat-select [(ngModel)]="project.vGrooveOffset">
            <mat-select-trigger>
              {{ project.vGrooveOffset > 0 ? (project.vGrooveOffset | size:'multichar' | inches) : 'None' }}
            </mat-select-trigger>
            <mat-option [value]="0" (click)="vGrooveYesNo = false">
              Remove V-Groove
            </mat-option>
            @for (vGrooveOffset of project.availableVGrooveOffsets.asArray; track vGrooveOffset.value) {
              <mat-option [value]="vGrooveOffset.value">
                {{ vGrooveOffset.value | size:'multichar' | inches }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
    </div>
    <div *ngIf="productCategory.projectProperty === 'bottomMat' && project.bottomMat">
      <div class="title">
        <mat-icon svgIcon="information-outline" (click)="infoClicked($event, 'reveal')"></mat-icon>
        REVEAL
      </div>
      <mat-form-field class="reveal">
        <mat-select [(ngModel)]="project.reveal">
          <mat-select-trigger>
            {{ project.reveal | size:'multichar' | inches }}
          </mat-select-trigger>
          @for (reveal of project.availableReveals.asArray; track reveal.value) {
          <mat-option [value]="reveal.value">
            {{ reveal.value | size:'multichar' | inches }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
